import { Reveal } from "./Reveal";
import { SKILLS } from "../lib/data";
import { PenTool, Code2, Smartphone, Sparkles } from "lucide-react";

const ICONS = { PenTool, Code2, Smartphone, Sparkles };

export const Skills = () => {
  return (
    <section id="skills" className="py-24 lg:py-32" data-testid="skills-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal>
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-brand mb-6">Skills & expertise</p>
          <h2 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl tracking-tight text-ink max-w-3xl">
            Design and code, <span className="text-gradient">under one roof.</span>
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {SKILLS.map((s, i) => {
            const Icon = ICONS[s.icon];
            return (
              <Reveal key={s.title} delay={i * 0.08} className="h-full">
                <div className="group h-full glass rounded-3xl p-8 hover:-translate-y-1.5 transition-transform duration-300 flex flex-col" data-testid={`skill-card-${i}`}>
                  <div className="w-14 h-14 rounded-2xl btn-gradient flex items-center justify-center mb-6 shadow-lg shadow-brand/20">
                    <Icon className="w-6 h-6 text-white" strokeWidth={1.7} />
                  </div>
                  <h3 className="font-display font-semibold text-xl text-ink mb-3">{s.title}</h3>
                  <p className="text-ink-soft leading-relaxed font-light text-[15px] mb-6 flex-1">{s.desc}</p>
                  <div className="flex flex-wrap gap-2">
                    {s.tags.map((t) => (
                      <span key={t} className="text-xs font-medium text-ink-soft border border-line rounded-full px-3 py-1">{t}</span>
                    ))}
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
